export default __webpack_public_path__ + "static/media/play-2.591b58ba.png";